import { render, staticRenderFns } from "./page-edit-one-media-asset.vue?vue&type=template&id=edc8cb24&scoped=true&"
import script from "./page-edit-one-media-asset.vue?vue&type=script&lang=js&"
export * from "./page-edit-one-media-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc8cb24",
  null
  
)

export default component.exports